import { HeaderRow } from '@/components/sections'
import { giphyBlack, giphyLightGrey } from '@giphy/colors'
import { SearchContext } from '@giphy/react-components'
import { useContext, useEffect } from 'react'
import styled, { css } from 'styled-components'
import { Avatar } from 'ui'
import { desktop } from 'ui/src/css'
import { CY_SEARCH_BAR__CHANNELS } from 'ui/src/utils/cy-test'
import { useSearchChannel } from '../../../api/hooks'
import DropdownPingback from './dropdown-pingback'
import _VerifiedBadge from './icons/verified-badge'

const ChannelItem = styled.div`
    cursor: pointer;
    display: flex;
    margin-bottom: 4px;
    padding: 10px;
`
const ChannelInfo = styled.div`
    margin-left: 5px;
    display: flex;
    flex-direction: column;
`
const DisplayName = styled.div`
    font-weight: bold;
    ${desktop(css`
        color: ${giphyBlack};
    `)}
`
const Username = styled.div`
    display: flex;
    align-items: center;
    color: ${giphyLightGrey};
    ${desktop(css`
        color: ${giphyBlack};
    `)}
    font-weight: 500;
`
const VerifiedBadge = styled(_VerifiedBadge)`
    margin-left: 2px;
`

const Channels = () => {
    const { term, setActiveChannel, setChannels, activeChannel } = useContext(SearchContext)
    const isChannelSearch = term.indexOf('@') === 0
    const limit = isChannelSearch ? 6 : 3
    const search = activeChannel ? '' : term.indexOf('@') === 0 ? term.split(' ')[0] : term
    const { data: channels } = useSearchChannel(search, { limit })
    useEffect(() => {
        if (channels?.data) {
            setChannels(channels.data)
        }
    }, [channels, setChannels])
    return channels && channels.data?.length > 0 ? (
        <>
            <HeaderRow>
                <h4 className="text-giphyWhite md:bg-giphyLightestGrey md:pl-1 md:text-giphyDarkCharcoal">Channels</h4>
            </HeaderRow>
            {channels.data?.map((channel) => {
                return (
                    <DropdownPingback
                        key={channel.id}
                        responseId={channels.meta.response_id}
                        arp={channel.analytics_response_payload}
                        eventType="DROPDOWN_CHANNEL_SUGGEST"
                        onClick={() => {
                            isChannelSearch ? setActiveChannel(channel) : (location.href = `/${channel.slug}`)
                        }}
                    >
                        <ChannelItem className={CY_SEARCH_BAR__CHANNELS}>
                            <Avatar user={channel.user} />
                            <ChannelInfo>
                                <DisplayName>{channel.display_name}</DisplayName>
                                <Username>
                                    @{channel.user.username}
                                    <VerifiedBadge size={12} />
                                </Username>
                            </ChannelInfo>
                        </ChannelItem>
                    </DropdownPingback>
                )
            })}
        </>
    ) : null
}
export default Channels
